export class Ranking {
  public name: string;
  public deliveredvalue: number;
  constructor(
    name: string,
    deliveredvalue: number) {
      this.name = name;
      this.deliveredvalue = deliveredvalue;
    }
}